// initial state
const state = {
  employmentTypeMap: { 1: '实习生', 2: '兼职' },
  educationLevelMap: { 1: '专科', 2: '本科', 3: '研究生' },
  officeLocationMap: {
    1: '临港',
    2: '陆家嘴',
    3: '客户公司',
    4: '线上',
    5: '成都',
    6: '其他',
  },
  gradeLevelMap: {
    1: '大一',
    2: '大二',
    3: '大三',
    4: '大四',
    5: '研一',
    6: '研二',
    7: '研三',
    8: '已毕业'
  },
  statusMap: { 1: '活跃', 2: '待机', 3: '离职' }
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const auditIntern = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/audit-intern/audit-intern.store.js